var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c(_vm.button,{directives:[{name:"b-modal",rawName:"v-b-modal",value:(_vm.id),expression:"id"}],tag:"component"},[_vm._v(_vm._s(_vm.textTitle)+" ")]),_c('b-modal',_vm._b({attrs:{"id":_vm.id,"title":_vm.textTitle,"ok-only":"","static":""}},'b-modal',_vm.$attrs,false),[_c('div',{staticClass:"hide-title"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }